/**
 * Query Key factory for all sick note queries.
 *
 * @module SickNote
 */

export const sickNoteQKeys = {
  all: () => ["sickNotes"] as const,
  //   allWithFilters: (filters?: { userId?: string }) =>
  //     [...sickNoteQKeys.all(), { ...filters }] as const,

  patients: () => [...sickNoteQKeys.all(), "patient"] as const,

  patient: (patientId: string) =>
    [...sickNoteQKeys.patients(), patientId] as const,
};
